import { AbstractApi } from ".";

const axios = window.axios;

class AmoCrmIntegrationApi extends AbstractApi {
    baseUrl = '/api/amocrm';

    show() {
        return this.get(this.baseUrl);
    }

    store(payload) {
        return this.post(this.baseUrl, payload);
    }

    update(payload) {
        return this.put(this.baseUrl, payload);
    }

    destroy() {
        return this.delete(this.baseUrl);
    }
}

export default new AmoCrmIntegrationApi();
